import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import cookie from "react-cookies";
import { ANLoadingScreen } from "@answersnow/pkg-theme";
import actions from "../../actions";
import { getSignedinState, getGroups } from "../../selectors";

const mapStateToProps = (state) => ({
  signedInState: getSignedinState(state),
  groups: getGroups(state),
});

const mapDispatchToProps = {
  checkAuthState: actions.checkAuthState,
};

/**
 * Landing component for the "/" route.
 *
 * Login is owned by the external auth portal — there is no in-app login form.
 * This component only routes an already-authenticated user to their landing
 * page. If the user is NOT authenticated, the auth saga (triggered by
 * checkAuthState) redirects to the portal, so we just show a loading screen
 * until that resolves.
 */
class RootRedirect extends Component {
  componentDidMount() {
    this.props.checkAuthState();
    this.redirectIfReady();
  }

  componentDidUpdate() {
    this.redirectIfReady();
  }

  redirectIfReady() {
    const { signedInState, groups, history } = this.props;
    if (signedInState !== true || !groups || groups.length === 0) return;

    const userId = cookie.load("userId");
    const clientId = userId ? cookie.load(`${userId}-clientId`) : null;

    // Caregivers without a selected client choose one first.
    if (groups.includes("Caregivers") && !clientId) {
      history.replace("/account-selection");
      return;
    }
    history.replace("/dashboard");
  }

  render() {
    return <ANLoadingScreen />;
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RootRedirect));
